"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUE = exports.TYPE = void 0;
const types_1 = require("./types");
exports.TYPE = 'embedded';
exports.DEFAULT_VALUE = {
    type: types_1.EmbeddedSourceEnum.html,
    zipFile: null,
    completion: types_1.EmbeddedCompletionEnum.none,
};
